/**
 * @generated SignedSource<<2d1055406e7b32f46d268e5fe7692264>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CompanyProfileReportModalCompanyQuery$variables = {};
export type CompanyProfileReportModalCompanyQuery$data = {
  readonly allReportReasons: ReadonlyArray<{
    readonly id: string;
    readonly text: any;
  } | null> | null;
};
export type CompanyProfileReportModalCompanyQuery = {
  response: CompanyProfileReportModalCompanyQuery$data;
  variables: CompanyProfileReportModalCompanyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CompanyReportReasonNode",
    "kind": "LinkedField",
    "name": "allReportReasons",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "text",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CompanyProfileReportModalCompanyQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CompanyProfileReportModalCompanyQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "070b9f38643ece75984924e61a0b221d",
    "id": null,
    "metadata": {},
    "name": "CompanyProfileReportModalCompanyQuery",
    "operationKind": "query",
    "text": "query CompanyProfileReportModalCompanyQuery {\n  allReportReasons {\n    id\n    text\n  }\n}\n"
  }
};
})();

(node as any).hash = "1a9058ded93ad1ff5b767e09ce3a94f5";

export default node;
